export const INDUCTION_COND_LIST = 'INDUCTION_COND_LIST';
export const INDUCTION_COND_ADD_SUCCESS = 'INDUCTION_COND_ADD_SUCCESS';
export const INDUCTION_COND_EDIT_SUCCESS = 'INDUCTION_COND_EDIT_SUCCESS';
export const COMPONENT_LIST = 'COMPONENT_LIST';
export const INDUCTION_COND_LOADER = 'INDUCTION_COND_LOADER';
export const CONTRACT_CONDN_LIST = 'CONTRACT_CONDN_LIST';
export const INDUCTION_COND_CRUD = 'INDUCTION_COND_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
